export function msToFrames(ms: number, fps: number): number {
  return Math.round((ms / 1000) * fps);
}

export function framesToMs(frames: number, fps: number): number {
  return Math.round((frames / fps) * 1000);
}

export function calculateDurationFrames(durationMs: number, fps: number): number {
  return Math.ceil((durationMs / 1000) * fps);
}

export function getFrameAtTime(timeMs: number, fps: number): number {
  return Math.floor((timeMs / 1000) * fps);
}

export function getTimeAtFrame(frame: number, fps: number): number {
  return (frame / fps) * 1000;
}

export function calculateSegmentFrameRange(
  tsStartMs: number,
  tsEndMs: number | null,
  totalDurationMs: number,
  fps: number
): { startFrame: number; endFrame: number; durationFrames: number } {
  const startFrame = msToFrames(tsStartMs, fps);
  const endMs = tsEndMs ?? totalDurationMs;
  const endFrame = msToFrames(endMs, fps);

  return {
    startFrame,
    endFrame,
    durationFrames: Math.max(endFrame - startFrame, 1),
  };
}
